export default function RadioInputButtonBlack({
  label,
  name,
  onChange,
  value,
}: {
  label?: string
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  value: string
}) {
  return (
    <label className="w-full cursor-pointer rounded-full border border-custom-black bg-custom-black px-8 py-6 text-center text-xl font-bold text-white shadow-[0_25px_30px_-10px_rgba(38,57,77,0.6)] drop-shadow hover:opacity-80">
      <input
        className="hidden"
        name={name}
        onChange={onChange}
        type="radio"
        value={value}
      />

      {label}
    </label>
  )
}
